import { observer } from 'mobx-react-lite';
import React, { useContext } from 'react';
import { AiTriggerElement as AiTriggerElementModel } from '../../../../models/ConversationHistory/HistoryElement/TriggerHistoryElement/AiTriggerElement';
import rootStore from '../../../../stores/rootStore';
import { useGetIcon } from '../../../customHooks/useGetIcon';
import BaseHistoryElement from '../BaseHistoryElement';

interface IProps {
  element: AiTriggerElementModel;
}

const ListTriggerElement: React.FC<IProps> = ({ element }: IProps) => {
  const getIcon = useGetIcon();
  const { blockStore } = useContext(rootStore);
  const block = blockStore?.allBlocks?.find(
    (block) => block?.trigger?.id === element.triggerId
  );

  return (
    <BaseHistoryElement
      element={element}
      title='AI Trigger evaluated'
      icon={getIcon('brain')}
    >
      {element.triggered ? (
        <div className='card-paragraph'>
          <i className={getIcon('check')}> </i>
          <span> Triggered block "{block?.title}" </span>
        </div>
      ) : (
        <div className='card-paragraph'>
          <i className={getIcon('error')}> </i>
          <span> Not triggered block "{block?.title}" </span>
        </div>
      )}
    </BaseHistoryElement>
  );
};

export default observer(ListTriggerElement);
